import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { setGmSecret } from '../lib/gm.js';

/**
 * Маршрут /gm/:secret — записує секрет у localStorage і кидає на /wiki.
 * Видавай посилання типу https://ivanvede-dh.duckdns.org/gm/<твій-секрет>
 * лише собі (зі сторінки клієнта секрет ніколи не йде нікому).
 */
export function GmLogin(): JSX.Element {
  const { secret = '' } = useParams<{ secret: string }>();

  useEffect(() => {
    if (secret) setGmSecret(secret);
  }, [secret]);

  return <Navigate to="/wiki" replace />;
}

export function GmLogout(): JSX.Element {
  useEffect(() => { setGmSecret(''); }, []);
  return <Navigate to="/wiki" replace />;
}
